import React, { useState, useEffect, ChangeEvent } from "react";

import { Input } from "@chakra-ui/input";
import { Checkbox } from "@chakra-ui/checkbox";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
interface IAddressInput {
  name: string;
  value: string;
  senderAddress: string;
  isDisabled: boolean;
  placeholder: string;
  onChange: (value: string) => void;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
}

const AddressInput: React.FC<IAddressInput> = ({
  name,
  value,
  senderAddress,
  isDisabled,
  placeholder,
  onChange,
  register,
  setValue,
}: IAddressInput) => {
  const [sameAsSender, setSameAsSender] = useState<boolean>();

  const receiverValidator = register(name);

  useEffect(() => {
    if (value === "") {
      setSameAsSender(false);
    }
  }, [value]);

  return (
    <>
      <Input
        borderRadius="0px"
        name={name}
        value={value}
        isDisabled={isDisabled}
        isReadOnly={sameAsSender === true}
        placeholder={placeholder}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          receiverValidator.onChange(event); // form validation
          onChange(event.target.value); // data passing
        }}
        onBlur={receiverValidator.onBlur}
        ref={receiverValidator.ref}
      />

      <Checkbox
        borderColor="brand.100"
        isChecked={sameAsSender}
        onChange={(event: any) => {
          setSameAsSender(event.target.checked);

          if (event.target.checked == true) {
            setValue(name, senderAddress, { shouldValidate: true });
            onChange(senderAddress);
          }
        }}
        isDisabled={isDisabled}
      >
        I want to send funds to my address
      </Checkbox>
    </>
  );
};

export default AddressInput;
